<template>
  <div class="pie-chart-container">
    <canvas ref="pie" id="pie-chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';
import { isNil, equals } from 'ramda';
import CommonMixin from '../mixins/common.js';
import FormatService from '../services/FormatService.js';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
import { mapGetters } from 'vuex';

Chart.plugins.unregister(ChartJsPluginDataLabels);

export default {
  name: 'pie-chart',
  props: {
    poll: Object,
    stats: Object
  },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' }),
    getType() {
      switch(this.poll.jsStyle.graphType.value) {
        case 'pie_chart': return 'pie';
        case 'doughnut_chart': return 'doughnut';
        default: return undefined;
      }
    }
  },
  data: () => ({
    chart: null,
    // default data to init the pie chart
    data: {
      datasets: [
        {
          data: [1],
          backgroundColor: ['rgba(0,0,0,0.15)']
        }
      ],
      labels: ['default']
    },
    type: 'pie'
  }),
  methods: {
    ...CommonMixin.methods,

    formatProps(stats = this.stats) {
      if (stats.totalVoteCount === 0) {
        return this.data;
      }
      const answers = stats.answers || [];
      return {
        datasets: [
          {
            data: answers.map(a => a.voteCount),
            backgroundColor: answers.map((_, index) => this.getAnswerColor(this.poll, index))
          }
        ],
        labels: answers.map(a => a.texts[this.lang])
      };
    },

    createChart() {
      // eslint-disable-next-line no-undef
      this.chart = new Chart(this.$refs.pie, {
        plugins: [ChartJsPluginDataLabels],
        type: this.getType,
        data: isNil(this.stats) ? this.data : this.formatProps(),
        options: {
          legend: {
            display: false
          },
          plugins: {
            datalabels: {
              formatter: (value, context) => {
                // do not display the percentage if there is no votes for this answer
                if (value === '0') {
                  return '';
                }
                const index = context.dataIndex;
                const statAnswer = this.stats.answers[index];
                const percentage = FormatService.getPercent(
                  statAnswer.voteCount,
                  this.stats.totalVoteCount
                );
                if (percentage <= 10) {
                  return '';
                }
                return '';// hide label `${index + 1} - ${percentage}%`;
              },
              color: context => {
                const index = context.dataIndex;
                const answerColor = this.getAnswerColor(this.poll, index);
                return FormatService.invertColor(answerColor);
              },
              // do not show the label if it overlaps another one
              display: 'auto',
              font: {
                size: 40
              }
            }
          }
        }
      });
    }
  },
  watch: {
    stats(newStats, oldStats) {
      // createChart should not be called on 'mounted',
      // we dont want to create the chart when data is not available
      if (!this.chart) {
        this.createChart();
      }
      if (!equals(newStats, oldStats)) {
        this.chart.data = this.formatProps(newStats);
        this.chart.update();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
canvas {
  width: 100%;
}
</style>
